<ng-container *ngIf="bookingInfo$ | async as bookingInfo">
  <div class="modal-header">
    <h2 class="modal-title mb-0 fs-3 fw-bold">
      {{
        'title.booking-cancel'
          | translate
            : {
                bookingReference: bookingInfo.bookingReference
              }
      }}
    </h2>
    <button type="button" class="btn-close" (click)="bsModalRef.hide()" [attr.aria-label]="'button.close' | translate"></button>
  </div>

  <div class="modal-body" [formGroup]="form">
    <p>
      {{ 'message.booking-cancel-confirm' | translate }}
    </p>
    <div class="card mb-3">
      <div class="card-body">
        <p>
          <em>
            {{ 'booking.default.booked-at' | translate }}

            <time
              [dateTime]="
                bookingInfo.bookedAt | date: 'yyyy-MM-dd'
              "
            >
              {{
                bookingInfo.bookedAt
                  | localizedDate: 'mediumDate'
              }}
            </time>
          </em>
        </p>
        <p>
          {{ eventBooking.test.name }}
        </p>
        <p>
          <span>
            {{
              'booking.default.details.timeFormat.dayOfWeek'
                | translate
                  : {
                      timeSlot:
                        examEvent.testeventTime
                        | localizedDate: 'EEEE'
                    }
            }}
            <time
              [dateTime]="
                examEvent.testeventTime | date: 'yyyy-MM-dd'
              "
              >{{
                'booking.default.details.timeFormat.date'
                  | translate
                    : {
                        timeSlot:
                          examEvent.testeventTime
                          | localizedDate: 'mediumDate'
                      }
              }}</time
            >
          </span>
          <br />
          <span
            >{{
              'booking.default.details.timeFormat.area'
                | translate
                  : { testarea: examEvent.testarea }
            }}
          </span>
          <time
            [dateTime]="
              examEvent.testeventTime | date: 'HH:mm:ss'
            "
            >{{
              'booking.default.details.timeFormat.time'
                | translate
                  : {
                      timeSlot:
                        examEvent.testeventTime
                        | localizedDate: 'shortTime'
                    }
            }}</time
          >
        </p>
        <address>
          <span
            (click)="showAddress()"
            class="address-toggle cursor-pointer"
            [class.address-toggle-active]="isShowAddress"
          >
            {{ bookingInfo.testEvent.name }}
            <i class="bi" [class]="isShowAddress ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
          </span>
          <ng-container *ngIf="isShowAddress">
            <p>
              {{
                bookingInfo.testEvent.address
                  .streetAndNumber
              }}
              <br />
              {{ bookingInfo.testEvent.address.zip }}
              {{ bookingInfo.testEvent.address.city }}
              <br />
              {{ bookingInfo.testEvent.address.country }}
            </p>
          </ng-container>
        </address>
      </div>
    </div>

    <div>
      <p class="my-3">
        {{ 'label.paid-until-now' | translate }}
        <strong>
          {{
            bookingInfo.totalPaidAmount.amount
              | currency
                : bookingInfo.totalPaidAmount.currency
                : undefined
                : undefined
                : currentLanguage
          }}
        </strong>
      </p>
      <div class="d-flex flex-column">
        <div class="form-check">
          <input 
            type="radio"
            class="form-check-input"
            id="noRefund"
            formControlName="refundMethod"
            value="none"
          >
          <label class="form-check-label" for="noRefund">{{ 'label.no-refund' | translate }}</label>
        </div>

        <div class="form-check">
          <input 
            type="radio"
            class="form-check-input"
            id="manualRefund"
            formControlName="refundMethod"
            value="manual"
            [disabled]="!bookingInfo.totalPaidAmount.amount"
          >
          <label class="form-check-label" for="manualRefund">{{ 'label.manual-refund' | translate }}</label>
        </div>

        <!-- TODO: Not implemented yet, so disabled -->
        <div class="form-check">
          <input 
            type="radio"
            class="form-check-input"
            id="manualRefund"
            formControlName="refundMethod"
            value="automatic"
            [disabled]="true"
          >
          <label class="form-check-label" for="manualRefund">{{ 'label.refund-via-boti' | translate }}</label>
        </div>
      </div>
      <div class="mt-3">
        <app-form-field-textarea
          [field]="reason"
          [label]="
            'label.reason-for-cancelation' | translate
          "
        ></app-form-field-textarea>
      </div>
    </div>
  </div>

  <div class="modal-footer justify-content-between">
    <button
      class="btn btn-outline-primary"
      (click)="bsModalRef.hide()"
    >
      {{ 'button.cancel' | translate }}
    </button>
    <button
      class="btn btn-danger"
      cdkFocusInitial
      (click)="cancellationBooking()"
      [disabled]="!form.valid"
    >
      {{ 'button.booking-cancel' | translate }}
    </button>
  </div>
</ng-container>

<app-loading-indicator-full
  *ngIf="isLoading"
></app-loading-indicator-full>
